export function formatPercentage(value: number, total: number) {
  if (!total) return ` (100%) ${value.toFixed(1)} / 0`

  const percentage = (value * 100) / total

  return ` (${percentage > 100 ? 100 : percentage.toFixed(1)} %) ${value.toFixed(1)} / ${total?.toFixed(1) ?? 0}`
}
